import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../../../assets/jss/adescom/adescomStyle';
import {
    ComponentTypeParams,
    SimCardServiceItem,
    SimCardServiceTypeItem,
} from '../../../../../interfaces/collections/SimCardServiceInterface';
import React, { FunctionComponent, ReactElement } from 'react';
import { roles, UserRoleHelper } from '../../../../../helpers/UserRoleHelper';
import { FeatureVerbTypeMap } from '../../../../../modules/features/FeaturesTypes';
import { TableCell, TableRow } from '@material-ui/core';
import { DateHelper } from '../../../../../helpers/DateHelper';
import DeleteButton from '../../../../../components/Buttons/DeleteButton';
import TemplateButton from '../../../../../components/Buttons/TemplateButton';
import { Settings } from '@material-ui/icons';
import { ServicesMvneType } from '../../../../../modules/lib/hooks/useOperatorType';
import { BmeParams } from '../Active/BmeParams';
import { McBmeParams } from '../Active/McBmeParams';
import { SdgParams } from '../Active/SdgParams';
import { ReactComponent as UpCurvedArrow } from '../../../../../assets/themes/OPL/img/icons/UpCurvedArrow.svg';


const useStyle = makeStyles(adescomStyle);

type AwaitingFeatureItemSdgBmeType = {
    simCardService: SimCardServiceItem;
    openComponentParamsDialog: (
        verbType: any,
    ) => void;
    forceStartComponent: (
        verbType: any,
    ) => void;
};

export const AwaitingFeatureItemSdgBme: FunctionComponent<AwaitingFeatureItemSdgBmeType> = ({
                                                                                            simCardService,
                                                                                            openComponentParamsDialog,
                                                                                                forceStartComponent,
                                                                                        }): ReactElement => {
    const classes = useStyle();

    const tableCellRoot = { root: classes.tableCellRoot };
    const allowOperation = UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_SERVICES_POST);

    let deleteParam: ComponentTypeParams | null = null;
    let modifyParam: ComponentTypeParams | null = null;

    if (simCardService.simCardServiceType.simCardServiceTypeParam) {
        for (let i = 0; i < simCardService.simCardServiceType.simCardServiceTypeParam.length; i++) {
            if (simCardService.simCardServiceType.simCardServiceTypeParam[i].verb === FeatureVerbTypeMap.DEACTIVATE) {
                deleteParam = simCardService.simCardServiceType.simCardServiceTypeParam[i];
            }
            if (simCardService.simCardServiceType.simCardServiceTypeParam[i].verb === FeatureVerbTypeMap.MODIFY) {
                modifyParam = simCardService.simCardServiceType.simCardServiceTypeParam[i];
            }
        }
    }

    const isHasModifyParams = (): boolean => modifyParam !== null;

    const isHasDeleteParams = (): boolean => deleteParam !== null;

    return (
        <React.Fragment>
            <TableRow hover={true}>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {simCardService.simCardServiceType.mainname}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {simCardService.simCardServiceType.description}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {DateHelper.format(simCardService.createdAt)}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="right">


                    {simCardService.deletedAt === null && allowOperation && UserRoleHelper.checkRole(roles.ROLE_PLATFORM_SIMCARD_SERVICE_TYPE_PENDING_DELETE) && (
                        <DeleteButton
                            disabled={!(simCardService.deletedAt === null)}
                            callback={(): void =>
                                openComponentParamsDialog({
                                    pendingId: simCardService.id,
                                    status: 5,
                                    simCardId: simCardService.simCardServiceType.id,
                                    componentName: simCardService.simCardServiceType.mainname,
                                })
                            }
                            callbackParam={{}}
                            tooltipTitle="prov:feature.delete_feature"
                        />
                    )}
                    {simCardService.deletedAt === null  && allowOperation && (
                        <TemplateButton
                            tooltipTitle="prov:feature.force_start_awaiting"
                            callback={(): void => {
                                forceStartComponent({
                                    pendingId: simCardService.id,
                                    status: 6,
                                    simCardId: simCardService.simCardServiceType.id,
                                    componentName: simCardService.simCardServiceType.mainname,
                                });
                            }}
                            icon={UpCurvedArrow}
                            callbackParam={{}}
                        />

                        )}
                </TableCell>
            </TableRow>
            {/*{simCardService.simCardServiceType.serviceType === ServicesMvneType.BME && <BmeParams simCardService={simCardService} />}*/}
            {/*{simCardService.simCardServiceType.serviceType === ServicesMvneType.MCBME && <McBmeParams simCardService={simCardService} />}*/}
            {/*{simCardService.simCardServiceType.serviceType === ServicesMvneType.SDG && <SdgParams simCardService={simCardService} />}*/}
        </React.Fragment>
    );
};
